import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Carousel, Tooltip, Row, Col, message } from 'antd';
// eslint-disable-next-line no-unused-vars
import { AlarmEventType, WheelInfoItem } from '../../redux/type';
import { enumTranslator } from '../../utils';
import { api } from '../../fetch/bussiness/api';
import { request } from '../../fetch/core';
import { HttpStatusCode } from '../../fetch/core/constant';
import Label from '../Label';
import { Method } from '@/fetch/core/util';
interface Props {
  alarmEvent: {
    alarmEvent: string;
    reportTime: string;
  }[];
  vehicleName: string;
}
const CarouselItem = (props: Props) => {
  const { alarmEvent, vehicleName } = props;
  const [wheelInfo, setWheelInfo] = useState<WheelInfoItem[]>([]);
  const [domainInfo, setDomainInfo] = useState<any>();
  const showHoverInfoType = [
    'LOW_PRESSURE',
    'PRESSURE_SHARP_DECREASE',
    'DOMAIN_CONTROLLER_ALARM',
  ];

  const getAlarmEventHoverInfo = (alarmEvent: string) => {
    if (alarmEvent === 'DOMAIN_CONTROLLER_ALARM') {
      return getDomainHoverInfo(domainInfo);
    } else {
      return getWheelHoverInfo(wheelInfo, alarmEvent);
    }
  };

  const getDomainHoverInfo = (domainInfo: any) => {
    const infoItems = [];
    if (domainInfo?.socTemperature != null) {
      infoItems.push(`SOC温度 ${domainInfo.socTemperature}度`);
    }
    if (domainInfo?.cpuLoad != null) {
      infoItems.push(`CPU负载率 ${domainInfo.cpuLoad}%`);
    }
    if (domainInfo?.memoryUsageRate != null) {
      infoItems.push(`内存占用率 ${domainInfo.memoryUsageRate}%`);
    }
    if (domainInfo?.diskUsageRate != null) {
      infoItems.push(`硬盘使用率 ${domainInfo.diskUsageRate}%`);
    }
    if (domainInfo?.diskTemperature != null) {
      infoItems.push(`硬盘温度 ${domainInfo.diskTemperature}℃`);
    }

    return (
      <>
        {infoItems.map((item, index) => (
          <div key={index}>{item}</div>
        ))}
      </>
    );
  };
  const getWheelHoverInfo = (
    wheelInfo: WheelInfoItem[],
    alarmEvent: string
  ) => {
    const title = (
      <>
        {wheelInfo &&
          wheelInfo.map((item: WheelInfoItem, index: number) => {
            return (
              <div key={index}>
                {item.wheelPosition}：{item.pressureStatus} {item.pressure}
              </div>
            );
          })}
      </>
    );
    return title;
  };

  const getAlarmEventDetail = async (
    isVisible: boolean,
    alarmEvent: string
  ) => {
    if (isVisible) {
      alarmEvent === 'DOMAIN_CONTROLLER_ALARM'
        ? getDomainInfo()
        : getVehicleWheelInfo();
    }
  };
  const getVehicleWheelInfo = async () => {
    const requestParam: RequestOptions = {
      path: api.getVehicleWheelInfo,
      method: Method.POST,
      body: {
        vehicleName,
      },
    };
    const res: any = await request(requestParam);
    if (res.code === HttpStatusCode.Success) {
      setWheelInfo(res.data);
    } else {
      message.error(res.message || '接口请求报错');
    }
  };

  const getDomainInfo = async () => {
    const requestParam: RequestOptions = {
      path: '/monitor/web/hardware/domain_info',
      method: Method.POST,
      body: {
        vehicleName,
      },
    };
    const res: any = await request(requestParam);
    if (res.code === HttpStatusCode.Success) {
      setDomainInfo(res.data);
    } else {
      message.error(res.message || '接口请求报错');
    }
  };

  const solutionList: any = [];
  alarmEvent &&
    alarmEvent.forEach((item: any, index: number) => {
      const solution =
        enumTranslator('ALARM_SOLUTION_ENUM', item.alarmEvent) || {};
      solutionList.push(solution);
    });

  return (
    <>
      <Row>
        <Col span={5} className="label">
          报警事件
        </Col>
        <Col span={17} className="value">
          {alarmEvent?.map(
            (
              item: { alarmEvent: string; reportTime: string },
              index: number
            ) => (
              <Label
                text={enumTranslator('ALARM_EVENT_ENUM', item.alarmEvent)}
                timeStamp={item.reportTime}
                tipInfo={
                  showHoverInfoType.includes(item.alarmEvent)
                    ? getAlarmEventHoverInfo(item.alarmEvent)
                    : ''
                }
                trigger={(isVisible) =>
                  getAlarmEventDetail(isVisible, item.alarmEvent)
                }
                key={index}
              />
            )
          )}
        </Col>
      </Row>
      <Row>
        <Col span={5} className="label">
          解决方案
        </Col>
        <Col span={17} className="value">
          {solutionList.join(',')}
        </Col>
      </Row>
    </>
  );
};
export default CarouselItem;
